<template>
    <ValidationObserver
        v-slot="{ invalid }"
        ref="observer"
        tag="form"
        @keydown.prevent.enter="submit"
    >
        <TextFieldWithValidation
            v-if="!submitted"
            v-model="email"
            type="text"
            auto-focus
            required
            :label="$t('email')"
            name="email"
            autocomplete="email"
            placeholder="email@domain.com"
            rules="required|email"
        />
        <p
            v-else
            class="mb-2"
        >
            {{ $t('forgotPasswordSuccess', { email }) }}
        </p>
        <div class="flex items-center justify-between">
            <AntButton
                v-if="!submitted"
                type="primary"
                :disabled="invalid || !validationObserverReady"
                :loading="loading"
                @click="submit"
            >
                {{ $t('request') }}
            </AntButton>
            <span class="text-gray-700">
                <RouterLink :to="{ name: 'login' }">
                    {{ $t('login') }}
                </RouterLink>
            </span>
        </div>
    </ValidationObserver>
</template>

<script>
import validationObserverMixin from '@/mixins/validationObserver';
import TextFieldWithValidation from '@/components/forms/elements/withValidation/TextFieldWithValidation.vue';
import { Button } from 'ant-design-vue';
export default {
    name: 'ForgotPassword',
    components: {
        AntButton: Button,
        TextFieldWithValidation,
    },
    mixins: [validationObserverMixin],
    data: () => ({
        submitted: false,
        email: '',
        loading: false,
    }),
    methods: {
        async submit() {
            if (!await this.$refs.observer.validate()) {
                return;
            }

            this.loading = true;

            const { email } = this.$data;

            this.$http.post('forgot-password', { email })
                .then(() => this.submitted = true)
                .catch(this.$refs.observer.setErrors)
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
